export default __webpack_public_path__ + "static/media/Vector.e5c50bdf.svg";